import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { homePath } from "@/lib/access";
import { hasCustomArea } from "@/lib/customAccess";

// Si no le toca, cada usuario vuelve a SU pagina de inicio (antes siempre a /dashboard,
// que no todos pueden ver).
// Fix AW (2026-10-27): `area` = seccion que habilita la pagina a un usuario con
// rol personalizado (ademas de los roles de `allowedRoles`).
export default function ProtectedRoute({ children, allowedRoles, area }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background font-sans text-secondary-foreground" data-testid="auth-loading-state">
        Cargando...
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role) && !(area && hasCustomArea(user, area))) {
    return <Navigate to={homePath(user)} replace />;
  }

  return children;
}
